export const permissionPolicy = JSON.stringify(
  {
    Condition: {
      StringLike: {
        'SAML:aud': 'https://*.mobileconnectcloud.com/*',
      },
    },
  },
  null,
  4,
)
  .substring(2)
  .slice(0, -2)
